import { Component, OnInit, Input, ViewChild, ElementRef, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { TrustAddressModel } from '../../models/trust-address';
import { MatSnackBar } from '@angular/material';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})


export class AddressComponent implements OnInit, AfterContentInit {

  @ViewChild('addressLabel') labelField: ElementRef;

  @Input() trustAddressModel: TrustAddressModel;
  @Output() trustAddressModelChange: EventEmitter<TrustAddressModel> = new EventEmitter<TrustAddressModel>();

  @Input() newAddress: boolean;
  @Output() newAddressChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() added: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() editable: boolean;


  public editing = false;
  public focused = false;

  undoModel: TrustAddressModel = new TrustAddressModel();

  constructor(private matSnackBar: MatSnackBar, private trustDataService: TrustDataService) { }

  ngOnInit() {

  }

  ngAfterContentInit() {
    if (this.newAddress === true) {
      this.editing = this.newAddress;
      setTimeout(() => {
        if (this.labelField) {
          this.labelField.nativeElement.focus();
        }
      });
    }
  }


  undoEdit() {
    if (this.trustAddressModel.Id > 0) {
      this.trustAddressModel = Object.assign(this.trustAddressModel, this.undoModel);
      this.editing = false;
    } else {
      this.newAddress = false;
      this.editing = false;
      this.trustAddressModel = null;
      this.newAddressChange.emit(false);
    }
  }

  editAddress(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.editable) {
      return;
    }
    this.editing = true;

    setTimeout(() => {
      if (this.labelField) {
        if (!this.focused) {
          this.labelField.nativeElement.focus();
          this.focused = true;
        }
      }

    });
    this.undoModel = Object.assign(this.undoModel, this.trustAddressModel);
  }

  updateAddress(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.focused = false;
    this.editing = false;
    if (this.trustAddressModel.Id > 0) {
      this.trustDataService.updateTrustAddress(this.trustAddressModel)
        .subscribe(response => {
          this.matSnackBar.open('Address Updated', null, { duration: 3000 });
          this.newAddressChange.emit(false);
        });
    } else {
      this.trustDataService.addTrustAddress(this.trustAddressModel)
        .subscribe(response => {
          this.matSnackBar.open('Address Added', null, { duration: 3000 });
          this.newAddressChange.emit(false);
          this.trustAddressModel = response.json();
          this.newAddressChange.emit(false);
          this.trustAddressModelChange.emit(this.trustAddressModel);
          this.added.emit(true);
        });
    }

  }

  deleteAddress(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.trustDataService.deleteTrustAddress(this.trustAddressModel)
      .subscribe(response => {
        this.matSnackBar.open('Address Deleted', null, { duration: 3000 });
        this.trustAddressModel = null;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/address/address.component.ts